import { useQuery } from '@tanstack/react-query'
import api from '../api'

const fetchBrands = async () => {
  // Brand controller paginates by default (15 per page), we fetch the first page.
  const res = await api.get('/brand', { params: { per_page: 100 } })
  // If paginated, the list is in res.data.data.data. Otherwise fallback to res.data.data or res.data
  return res.data?.data?.data || res.data?.data || res.data || []
}

export const useBrands = (options = {}) => {
  return useQuery({
    queryKey: ['brands'],
    queryFn: fetchBrands,
    staleTime: 1000 * 60 * 60, // Cache for 1 hour since brands change infrequently
    ...options,
  })
}

export default useBrands;
